import { render, staticRenderFns } from "./FixStocks.vue?vue&type=template&id=98bcc722&"
import script from "./FixStocks.vue?vue&type=script&lang=js&"
export * from "./FixStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports